
import { ChannelForm } from './ChannelForm';

export class EpgConfigForm {
  // parentForm: ChannelForm = null;

  // default to an empty array of events
  epgConfig: EpgConfig = { events: [] };

  static create(parentForm: ChannelForm): EpgConfigForm {
    const form = new EpgConfigForm();
    // form.parentForm = parentForm;
    return form;
  }

  static createFromData(parentForm: ChannelForm, data: ChannelFormData): EpgConfigForm {
    const form = new EpgConfigForm();
    // form.parentForm = parentForm;
    form.loadData(data);
    return form;
  }

  private constructor() {}

  loadData(data: ChannelFormData) {
    const { channel } = data;
    const epgConfig = channel.metaData.epgConfig;
    if (epgConfig) {
      this.epgConfig = epgConfig;
    }
  }
}
